import * as React from "react";

function SvgMusescore(props) {
  return (
    <svg
      viewBox="0 0 1000 1000"
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit={2}
      {...props}
    >
      <path d="M1000 0H0v1000h1000V0zM368.11 467.901c-25.137-34.763-74.691-57.581-120.863-57.581C170.95 410.32 100 457.189 100 585.811v215.636c0 14.616 11.855 26.381 26.469 26.381 14.625 0 26.48-11.853 26.48-26.381V585.811c-.027-97.75 47.144-122.634 94.298-122.634 47.152 0 94.306 39.196 94.306 105.349v232.921c0 14.616 11.855 26.381 26.469 26.381h.229c14.615 0 26.471-11.765 26.471-26.381V568.526c0-66.153 47.152-105.349 94.306-105.349 29.936 0 94.298 13.296 94.298 105.349l1.789 78.229c0 144.549 97.024 181.073 158.767 181.073 61.742 0 154.231-42.646 156.118-170.54V452.632c0-35.205-53.098-35.205-53.098 0v204.656c0 97.024-72.15 117.69-103.02 117.69-30.87 0-105.843-14.544-105.843-128.223l-1.764-73.949c0-109.641-68.8-166.897-147.247-166.897-46.174 0-95.779 27.229-120.918 61.992zm410.539-131.078c0-19.298-15.629-34.928-34.929-34.928-19.297 0-34.927 15.63-34.927 34.928 0 19.3 15.63 34.929 34.927 34.929 19.3 0 34.929-15.629 34.929-34.929zm-146.409-1.476c0-52.921 38.977-110.253 106.373-110.253 67.396 0 106.241 57.332 106.241 110.253 0 39.692 53.046 39.692 53.046 0 0-92.613-69.84-163.175-159.287-163.175-89.446 0-159.267 70.562-159.267 163.175.008 39.692 52.894 39.692 52.894 0z" />
    </svg>
  );
}

export default SvgMusescore;